import { render, staticRenderFns } from "./cookies-web.html?vue&type=template&id=b32f8a86&scoped=true&"
import script from "./cookies-web.ts?vue&type=script&lang=ts&"
export * from "./cookies-web.ts?vue&type=script&lang=ts&"
import style0 from "./cookies-web.scss?vue&type=style&index=0&id=b32f8a86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f8a86",
  null
  
)

export default component.exports